module.exports = __webpack_public_path__ + "img/mn.2dbebe3b.svg";